import {
  type DependencyList,
  type RefObject,
  useLayoutEffect,
  useState,
} from 'react';
import useResizeObserver from './useResizeObserver';

// Use this hook to detect if there are any overflowed elements in a container
const useOverflowedElements = (
  ref: RefObject<HTMLElement>,
  deps?: DependencyList
) => {
  const [hasOverflowedElements, setHasOverflowedElements] = useState(false);
  const checkIfHasOverflowedElements = () => {
    const wrapperElement = ref.current;
    if (!wrapperElement) return false;

    return setHasOverflowedElements(
      wrapperElement.scrollWidth > wrapperElement.clientWidth
    );
  };

  useLayoutEffect(() => {
    checkIfHasOverflowedElements();
  }, deps || []);

  useResizeObserver(ref, checkIfHasOverflowedElements);

  return {
    hasOverflowedElements,
  };
};

export default useOverflowedElements;
